import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

import { useAuthContext } from '~/shared/context/useAuthContext';
import runtimeEnv from '~/shared/utils/runtimeEnv';

import { getAreaFromPath, getSuggestionsForPath } from './suggestions';

export type HelpDefaults = {
  visitor: {
    unsignedClaims: {
      route: string;
      area: string;
      tenantId?: string;
      stage: string;
      version: string;
    };
  };
  suggestions: string[];
};

export function useHelpDefaults(): HelpDefaults {
  const { pathname } = useLocation();
  const { activeTenantId } = useAuthContext();

  return useMemo(() => {
    const area = getAreaFromPath(pathname);
    return {
      visitor: {
        unsignedClaims: {
          route: pathname,
          area,
          tenantId: activeTenantId,
          stage: runtimeEnv.stage,
          version: runtimeEnv.version,
        },
      },
      suggestions: getSuggestionsForPath(pathname),
    };
  }, [pathname, activeTenantId]);
}
